import React, { memo } from 'react';

import { InView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';

import {
    Avatar,
    Image,
    Link,
    SeeMore,
    Text,
} from 'reaxl';

import vdpRatingReviewDuck from '@/ducks/vdp/vdpRatingReviewDuck.js';

function ExpertReview() {

    const expertReview = useSelector((state) => vdpRatingReviewDuck.selectors.getExpertReview(state));

    if (!expertReview || !Object.keys(expertReview).length) {
        return null;
    }

    const renderSection = (key, title, content, titleColor = 'default') => (
        <div
            className="margin-bottom-4"
            key={key}
        >
            {
                title && (
                    <Text
                        color={titleColor}
                        weight="bold"
                    >
                        {title}
                    </Text>
                )
            }
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );

    const {
        pros,
        cons,
        quickNew,
        author: [author = {}] = [],
        lastModified,
        editorsOverview,
    } = expertReview;

    const {
        authorName = '',
        avatarUrls = {},
        link: authorLink,
    } = author;

    const reviewContent = [
        ['pros', 'Pros', pros, 'success'],
        ['cons', 'Cons', cons, 'danger'],
        ['quickNew', 'What\'s New?', quickNew],
        ['editorsOverview', null, editorsOverview],
    ].map((section) => renderSection(...section));

    return (
        <InView triggerOnce>
            {({ ref, inView }) => (
                <div
                    ref={ref}
                    data-cmp="expertReview"
                    className="padding-horizontal-2"
                >
                    {
                        inView && (
                            <>
                                <div
                                    className="display-flex margin-vertical-5 align-items-center gap-4"
                                >
                                    <Link
                                        href={authorLink}
                                    >
                                        {
                                            avatarUrls?.medium ? (
                                                <Image
                                                    src={avatarUrls.medium}
                                                    alt={authorName}
                                                    className="avatar"
                                                    lazyload={false}
                                                />
                                            ) : (
                                                <Avatar text={authorName} />
                                            )
                                        }
                                    </Link>
                                    <div>
                                        By
                                        {' '}
                                        <Link
                                            href={authorLink}
                                            className="text-bold text-gray-base"
                                        >
                                            {authorName}
                                        </Link>
                                        <Text
                                            color="subdued-lighter"
                                            size={200}
                                            componentClass="div"
                                        >
                                            Updated
                                            {' '}
                                            {lastModified}
                                        </Text>
                                    </div>
                                </div>
                                <SeeMore>
                                    {reviewContent}
                                </SeeMore>
                            </>
                        )
                    }
                </div>
            )}
        </InView>
    );
}

export default memo(ExpertReview);
